// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"145":"confirm-email","209":"staking","468":"holder-assembly","805":"transactions","809":"account","966":"dashboard"}[chunkId] + "." + {"145":"d3a646b2","209":"fe94bde8","468":"a154668a","805":"592326c6","809":"fadbc528","966":"6f78fa2d"}[chunkId] + ".css";
};